var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.001 11.988",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3866"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3863"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3288",
    d: "M6.177 11.989a.44.44 0 01-.312-.129L0 5.995 5.865.13a.441.441 0 01.624.624L1.248 5.995l5.241 5.241a.441.441 0 01-.312.753z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3864"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3289",
    d: "M12.56 11.989a.44.44 0 01-.312-.129L6.383 5.995 12.248.13a.441.441 0 01.624.624L7.631 5.995l5.241 5.241a.441.441 0 01-.312.753z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowLeft);
export default __webpack_public_path__ + "static/media/DoubleArrowLeft.a649b818.svg";
export { ForwardRef as ReactComponent };